import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import Direccion from "../utils/Direccion";
import { logger } from "../utils/utils";
import queryString from "query-string";
import config from "../config";
import Loader from "../utils/Loader";
import { parseJwt } from "../utils/utils";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

const agendiaLiteOptions = () => [
  { value: "SI", label: "SI" },
  { value: "SOLO", label: "SOLO AGENDIA LITE" },
  { value: "NO", label: "NO" },
];

const notificacionesOptions = () => [
  { value: "SI", label: "SI" },
  { value: "NO", label: "NO" },
];

const usaSegurosOptions = () => [
  { value: "SI", label: "SI" },
  { value: "NO", label: "NO" },
];

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

const estadoInternoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "SUSPENDIDO", label: "SUSPENDIDO" },
  { value: "ELIMINADO", label: "ELIMINADO" },
];

const pagoAppOptions = () => [
  { value: "S", label: "Si" },
  { value: "N", label: "NO" },
  { value: "O", label: "OPCIONAL" },
];

const sucursalesOptions = () => [
  { value: true, label: "Si" },
  { value: false, label: "NO" },
];

const conceptoAPintarOptions = [
  { value: "profesional", label: "Profesionales" },
  { value: "servicio", label: "Servicios" },
];

function RenderCampo({ camposContacto, setCamposContacto, scope, title }) {
  return (
    <>
      <div style={{ marginTop: 20 }}>
        <strong>{title}</strong>
      </div>

      <Button
        text={camposContacto[scope].habilitado ? "Dejar de pedir" : "Pedir"}
        type={camposContacto[scope].habilitado ? "danger" : "primary"}
        onClick={() => {
          if (camposContacto[scope].habilitado) {
            const camposAux = { ...camposContacto };
            camposAux[scope].habilitado = false;
            setCamposContacto(camposAux);
          } else {
            const camposAux = { ...camposContacto };
            camposAux[scope].habilitado = true;
            setCamposContacto(camposAux);
          }
        }}
      />
      {camposContacto[scope].habilitado ? (
        <div style={{ marginTop: 20 }}>
          <Button
            text={
              camposContacto[scope].required
                ? "Marcar como no obligatorio"
                : "Marcar como obligatorio"
            }
            type={camposContacto[scope].required ? "danger" : "primary"}
            onClick={() => {
              if (camposContacto[scope].required) {
                const camposAux = { ...camposContacto };
                camposAux[scope].required = false;
                setCamposContacto(camposAux);
              } else {
                const camposAux = { ...camposContacto };
                camposAux[scope].required = true;
                setCamposContacto(camposAux);
              }
            }}
          />
        </div>
      ) : null}
    </>
  );
}

function EditLocal({ history, match }) {
  const dispatch = useDispatch();

  const modelEditLocal = useSelector((state) => state.editLocal);
  const modelLocal = useSelector((state) => state.localById);
  const modelEliminacionImgLocal = useSelector((state) => {
    return state.eliminacionImgLocal;
  });
  const modelEliminacionImgBannerLocal = useSelector((state) => {
    return state.eliminacionImgBannerLocal;
  });

  const [nombre, setNombre] = useState(null);
  const [ciudad, setCiudad] = useState(null);
  const [direccion, setDireccion] = useState(null);
  const [horarioApertura, setHorarioApertura] = useState(null);
  const [horarioCierre, setHorarioCierre] = useState(null);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [pagoApp, setPagoApp] = useState("N");
  const [imagenes, setImagenes] = useState([]);
  const [imagenesBanner, setImagenesBanner] = useState([]);

  const [estado, setEstado] = useState("ACTIVO");
  const [estadoInterno, setEstadoInterno] = useState("ACTIVO");
  const [agendiaLite, setAgendiaLite] = useState("NO");
  const [linkAgendiaLite, setLinkAgendiaLite] = useState("");
  const [recibeNotificaciones, setRecibeNotificaciones] = useState("SI");
  const [enviaNotificaciones, setEnviaNotificaciones] = useState("SI");
  const [telefono, setTelefono] = useState("");
  const [telefonoMensaje, setTelefonoMensaje] = useState("");
  const [email, setEmail] = useState("");
  const [actualRol, setActualRol] = useState(null);
  const [descripcion, setDescripcion] = useState(null);
  const [localId, setLocalId] = useState(
    match.params.localId ? match.params.localId : null
  );
  const [bancard_id_local, setBancard_id_local] = useState(null);
  const [tiempoCancelar, setTiempoCancelar] = useState(null);
  const [bancard_id_sucursal, setBancard_id_sucursal] = useState(null);
  const [initialRegion, setInitialRegion] = useState(null);
  const [sucursales, setSucursales] = useState(false);
  const [conceptoPintar, setConceptoPintar] = useState("profesional");
  const [textoInformativo, setTextoInformativo] = useState(null);
  const [linktwitter, setLinkTwitter] = useState(null);
  const [linkinstagram, setLinkInstagram] = useState(null);
  const [linkfacebook, setLinkFacebook] = useState(null);
  const [usaSeguros, setUsaSeguros] = useState("NO");
  const [localTest, setLocalTest] = useState("false");
  const [urlTest, setUrlTest] = useState("");
  const [local, setLocal] = useState(null);

  const [camposContacto, setCamposContacto] = useState({
    telefono: {
      habilitado: true,
      required: true,
    },
    direccion: {
      habilitado: true,
      required: false,
    },
    email: {
      habilitado: true,
      required: false,
    },
    fechaNacimiento: {
      habilitado: true,
      required: false,
    },
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return history.push("/logout");
    }

    const decodedToken = parseJwt(token);

    setActualRol(decodedToken.rol);
    dispatch(controller.localByIdThunk(localId));
  }, []);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckLocalById.actions.clear());
    }
    if (data && data.data) {
      setLocal(data.data);
      setNombre(data.data.nombre);
      setCiudad(data.data.direccion.ciudad);
      setDireccion(data.data.direccion.calle);
      setLat(data.data.direccion.latitud);
      setLng(data.data.direccion.longitud);
      setPagoApp(
        data.data.metodo_pago === 20
          ? "S"
          : data.data.metodo_pago === 30
          ? "O"
          : "N"
      );
      setEstado(data.data.estado);
      setDescripcion(data.data.detalles.descripcion);
      setTextoInformativo(data.data.detalles.textoInformativo);
      setAgendiaLite(data.data.detalles.agendiaLite);
      setLinkAgendiaLite(data.data.detalles.linkagendialite);
      setHorarioApertura(data.data.detalles.horaHabil);
      setUsaSeguros(data.data.detalles.usaSeguros);
      setLocalTest(data.data.localTest ? "true" : "false");
      setUrlTest(data.data.urlTest || "");
      setLinkFacebook(data.data.detalles.linkfacebook);
      setLinkInstagram(data.data.detalles.linkinstagram);
      setLinkTwitter(data.data.detalles.linktwitter);
      setEmail(data.data.detalles.email);
      if (data.data.detalles.notificaciones) {
        setRecibeNotificaciones(data.data.detalles.notificaciones);
      }

      if (data.data.detalles.enviaNotificaciones) {
        setEnviaNotificaciones(data.data.detalles.enviaNotificaciones);
      }

      setTelefono(data.data.detalles.telefono);
      setTelefonoMensaje(data.data.detalles.telefonoMensaje);
      setBancard_id_local(data.data.bancard_id_local);
      setTiempoCancelar(data.data.tiempoCancelar);
      setBancard_id_sucursal(data.data.bancard_id_sucursal);
      setSucursales(data.data.sucursales.toString());
      setInitialRegion({
        lat: data.data.direccion.latitud,
        lng: data.data.direccion.longitud,
      });
      setImagenes(data.data.imagenes);
      setImagenesBanner(data.data.imagenesBanner);
      setConceptoPintar(
        data.data.conceptoPintar ? data.data.conceptoPintar : "profesional"
      );

      if (data.data.detalles.camposContacto) {
        setCamposContacto(data.data.detalles.camposContacto);
      }
      if (data.data.estadoInterno) {
        setEstadoInterno(data.data.estadoInterno);
      }

      dispatch(controller.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    const data = modelEditLocal?.data?.data;
    const error = modelEditLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckEditLocal.actions.clear());
    }

    if (data) {
      history.push("/");
      dispatch(controller.duckEditLocal.actions.clear());
    }
  }, [modelEditLocal]);

  useEffect(() => {
    // TODO usar "selectors" para data y error

    const data = modelEliminacionImgLocal?.data?.data?.data;
    const error = modelEliminacionImgLocal?.error;
    const errorMessage =
      modelEliminacionImgLocal?.error?.response?.data?.mensaje;

    if (error) {
      if (errorMessage) {
        alert(errorMessage);
      }
      // setImagenesListaLoading(false);
      dispatch(controller.duckLocalById.actions.clear());
    }

    if (data) {
      dispatch(controller.localByIdThunk(localId));
    }
  }, [modelEliminacionImgLocal, localId, dispatch]);

  useEffect(() => {
    // TODO usar "selectors" para data y error

    const data = modelEliminacionImgBannerLocal?.data?.data?.data;
    const error = modelEliminacionImgBannerLocal?.error;
    const errorMessage =
      modelEliminacionImgBannerLocal?.error?.response?.data?.mensaje;

    if (error) {
      if (errorMessage) {
        alert(errorMessage);
      }
      // setImagenesListaLoading(false);
      dispatch(controller.duckLocalById.actions.clear());
    }

    if (data) {
      dispatch(controller.localByIdThunk(localId));
    }
  }, [modelEliminacionImgBannerLocal, localId, dispatch]);

  const navegarASubirImagen = () => {
    const token = localStorage.getItem("token");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "local";
    const conceptoId = localId;

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/editLocal/${localId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subida de imágenes",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenALocal`,
      lastStepUrl,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    history.push(`/subirImagenes?${params}`);
  };

  const navegarASubirImagenBanner = () => {
    const token = localStorage.getItem("token");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "localBanner";
    const conceptoId = localId;

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/editLocal/${localId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subida de imágenes",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenBannerALocal`,
      lastStepUrl,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    history.push(`/subirImagenes?${params}`);
  };

  const doEliminarImagen = (imagenID) => {
    const token = localStorage.getItem("token");
    // setImagenesListaLoading(true);

    let data = {
      imagenID,
      localId: localId,
      token,
    };
    dispatch(controller.eliminarImgLocalThunk(data));
  };

  const doEliminarImagenBanner = (imagenID) => {
    const token = localStorage.getItem("token");
    // setImagenesListaLoading(true);

    let data = {
      imagenID,
      localId: localId,
      token,
    };
    dispatch(controller.eliminarImgBannerLocalThunk(data));
  };

  function submit() {
    if (
      !nombre ||
      !estado ||
      !ciudad ||
      !direccion ||
      !pagoApp ||
      !tiempoCancelar ||
      !enviaNotificaciones ||
      !recibeNotificaciones
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (
      (pagoApp === "S" || pagoApp === "O") &&
      !bancard_id_local &&
      !bancard_id_sucursal
    ) {
      alert(
        "Es necesario agregar el id de local y sucursal de bancard si el local tiene pago habilitado"
      );
      return;
    }

    if ((agendiaLite === "SI" || agendiaLite === "SOLO") && !linkAgendiaLite) {
      alert("Proporcione un link para agendia lite");
      return;
    }

    if (recibeNotificaciones === "SI" && !telefono) {
      alert(
        "Proporcione un numero de telefono para recibir las notificaciones"
      );
      return;
    }

    if (!enviaNotificaciones) {
      alert(
        "Proporcione un numero de telefono para recibir las notificaciones"
      );
      return;
    }

    let data = {
      _id: match.params.localId,
      nombre,
      estado,
      estadoInterno,
      ciudad,
      direccion,
      lat,
      lng,
      pagoApp,
      descripcion,
      sucursales,
      bancard_id_local,
      bancard_id_sucursal,
      tiempoCancelar,
      conceptoPintar,
      textoInformativo,
      horarioApertura,
      horarioCierre,
      agendiaLite,
      linkagendialite: linkAgendiaLite,
      recibeNotificaciones,
      enviaNotificaciones,
      telefono,
      telefonoMensaje,
      linkfacebook,
      linkinstagram,
      linktwitter,
      usaSeguros,
      localTest: localTest === "true",
      urlTest,
      camposContacto,
      email,
    };
    dispatch(controller.editLocalThunk(data));
  }

  return (
    <Content title="Editar local" browserTitle="Editar local" show={false}>
      <Row>
        <Col md="6" mdOffset="3" lg="4" lgOffset="4">
          <Box
            title="Editar local"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(`/`);
                  }}
                />
                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelEditLocal.loading}
                    >
                      Guardar cambios
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelEditLocal.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />

            {actualRol && actualRol === "superadmin" ? (
              <>
                <SelectInput
                  value={estadoInterno}
                  setValue={setEstadoInterno}
                  label="Estado interno"
                  options={estadoInternoOptions()}
                />

                <SelectInput
                  value={agendiaLite}
                  setValue={setAgendiaLite}
                  label="Usa Agendia Lite"
                  options={agendiaLiteOptions()}
                />
                {agendiaLite === "SI" || agendiaLite === "SOLO" ? (
                  <>
                    <Text
                      labelPosition="above"
                      size="sm"
                      label={
                        <Etiqueta
                          texto="Link para Agendia Lite"
                          obligatorio={true}
                        />
                      }
                      value={linkAgendiaLite}
                      onChange={(evt) => setLinkAgendiaLite(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      label="Facebook"
                      value={linkfacebook}
                      onChange={(evt) => setLinkFacebook(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      label="Twitter"
                      value={linktwitter}
                      onChange={(evt) => setLinkTwitter(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      label="Instagram"
                      value={linkinstagram}
                      onChange={(evt) => setLinkInstagram(evt.target.value)}
                    />
                  </>
                ) : null}
                {local && local.categoriaId === "60f7ed6a559e075075ed055a" ? (
                  <SelectInput
                    value={usaSeguros}
                    setValue={setUsaSeguros}
                    label="Utiliza seguros"
                    options={usaSegurosOptions()}
                  />
                ) : null}

                <SelectInput
                  value={localTest}
                  setValue={setLocalTest}
                  label="Local de prueba"
                  options={sucursalesOptions()}
                />
                {localTest === "true" ? (
                  <Text
                    labelPosition="above"
                    size="sm"
                    inputType="text"
                    label="URL de prueba"
                    value={urlTest}
                    onChange={(evt) => setUrlTest(evt.target.value)}
                  />
                ) : null}

                <SelectInput
                  value={enviaNotificaciones}
                  setValue={setEnviaNotificaciones}
                  label="Envia notificaciones a usuario"
                  options={notificacionesOptions()}
                />

                <SelectInput
                  value={recibeNotificaciones}
                  setValue={setRecibeNotificaciones}
                  label="Recibe notificaciones y genera recordatorios"
                  options={notificacionesOptions()}
                />
                {recibeNotificaciones === "SI" ? (
                  <>
                    <Text
                      labelPosition="above"
                      size="sm"
                      inputType="number"
                      label={
                        <Etiqueta
                          texto="Telefono (981XXXXXX)"
                          obligatorio={true}
                        />
                      }
                      value={telefono}
                      onChange={(evt) => setTelefono(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      inputType="text"
                      label={<Etiqueta texto="Email" obligatorio={true} />}
                      value={email}
                      onChange={(evt) => setEmail(evt.target.value)}
                    />
                    <Text
                      labelPosition="above"
                      size="sm"
                      inputType="text"
                      label="Nro Telefono Propio para enviar mensajes (Ej: 981XXXXXX)"
                      value={telefonoMensaje}
                      onChange={(evt) => setTelefonoMensaje(evt.target.value)}
                    />
                  </>
                ) : null}
              </>
            ) : null}
            <Text
              labelPosition="above"
              label="Descripcion"
              inputType="textarea"
              rows={5}
              value={descripcion}
              onChange={(evt) => setDescripcion(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Horario laboral"
              value={horarioApertura}
              onChange={(evt) => setHorarioApertura(evt.target.value)}
            />
            <label>Texto informativo</label>
            <div>
              <small className="text-muted">
                Es un aviso breve que aparece en la pantalla del local en la
                aplicación. Ej.: 'La factura se emitirá en el local'.
              </small>
            </div>
            <Text
              labelPosition="none"
              size="sm"
              value={textoInformativo}
              onChange={(evt) => setTextoInformativo(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Ciudad" obligatorio={true} />}
              value={ciudad}
              onChange={(evt) => setCiudad(evt.target.value)}
            />
            <div className="marginBottom20px">
              <Direccion
                direccion={direccion}
                setDireccion={setDireccion}
                initialRegion={initialRegion}
                setLat={setLat}
                setLng={setLng}
              />
            </div>

            <Text
              labelPosition="above"
              size="sm"
              inputType="number"
              label={
                <Etiqueta
                  texto="Tiempo para cancelar antes de reserva en minutos"
                  obligatorio={true}
                />
              }
              value={tiempoCancelar}
              onChange={(evt) => setTiempoCancelar(evt.target.value)}
            />
            <SelectInput
              value={pagoApp}
              setValue={setPagoApp}
              label="Pago vía App"
              options={pagoAppOptions()}
            />
            {pagoApp === "S" || pagoApp === "O" ? (
              <React.Fragment>
                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta
                      texto="ID de local (BANCARD)"
                      obligatorio={true}
                    />
                  }
                  value={bancard_id_local}
                  onChange={(evt) => setBancard_id_local(evt.target.value)}
                />
                <Text
                  inputType="number"
                  labelPosition="above"
                  size="sm"
                  label={
                    <Etiqueta
                      texto="ID de sucursal (BANCARD)"
                      obligatorio={true}
                    />
                  }
                  value={bancard_id_sucursal}
                  onChange={(evt) => setBancard_id_sucursal(evt.target.value)}
                />
              </React.Fragment>
            ) : null}
            {!match.params.categoriaId ? (
              <SelectInput
                value={sucursales}
                setValue={setSucursales}
                label="Posee sucursales"
                options={sucursalesOptions()}
              />
            ) : null}

            <h3>Configuracion de contactos</h3>

            <h4>Datos a pedir</h4>

            <Col md="6">
              <RenderCampo
                setCamposContacto={setCamposContacto}
                camposContacto={camposContacto}
                scope="telefono"
                title="Telefono"
              />
              <RenderCampo
                setCamposContacto={setCamposContacto}
                camposContacto={camposContacto}
                scope="direccion"
                title="Direccion"
              />
            </Col>
            <Col md="6">
              <RenderCampo
                setCamposContacto={setCamposContacto}
                camposContacto={camposContacto}
                scope="email"
                title="Email"
              />
              <RenderCampo
                setCamposContacto={setCamposContacto}
                camposContacto={camposContacto}
                scope="fechaNacimiento"
                title="Fecha de nacimiento"
              />
            </Col>
          </Box>
        </Col>
      </Row>

      <Row className="marginBottom20px">
        <Col md="6" mdOffset="3" lg="4" lgOffset="4">
          <div>
            <hr />
            <h4>Imagen de perfil</h4>
          </div>

          {imagenes && Array.isArray(imagenes) && imagenes.length
            ? imagenes.map((imagenObj, index) => {
                return (
                  <Box>
                    <div style={{ marginBottom: 20 }}>
                      <p>
                        <b>Nombre de archivo:</b>
                        <br />
                        {imagenObj.url.split("/").pop()}
                      </p>
                      <a href={imagenObj.url}>Ver imagen</a>
                    </div>
                    <Button
                      type="default"
                      text="Eliminar"
                      pullRight={true}
                      onClick={() => doEliminarImagen(imagenObj._id)}
                    />
                  </Box>
                );
              })
            : "Sin imagen de perfil"}
          <Button
            pullRight={true}
            type="primary"
            text="Subir imagen de perfil"
            onClick={navegarASubirImagen}
            className="minWidth200px"
          />
        </Col>
      </Row>
      <Row>
        <Col md="6" mdOffset="3" lg="4" lgOffset="4">
          <div>
            <hr />
            <h4>Imagen de banner</h4>
          </div>

          {imagenesBanner &&
          Array.isArray(imagenesBanner) &&
          imagenesBanner.length
            ? imagenesBanner.map((imagenObj, index) => {
                return (
                  <Box>
                    <div style={{ marginBottom: 20 }}>
                      <p>
                        <b>Nombre de archivo:</b>
                        <br />
                        {imagenObj.url.split("/").pop()}
                      </p>
                      <a href={imagenObj.url}>Ver imagen</a>
                    </div>
                    <Button
                      type="default"
                      text="Eliminar"
                      pullRight={true}
                      onClick={() => doEliminarImagenBanner(imagenObj._id)}
                    />
                  </Box>
                );
              })
            : "Sin imagen de banner"}
          <Button
            pullRight={true}
            type="primary"
            text="Subir imagen de banner"
            onClick={navegarASubirImagenBanner}
            className="minWidth200px"
          />
        </Col>
      </Row>
    </Content>
  );
}

export default EditLocal;
